import { Paths } from '../constants/Paths';
export function buildUpdatePaymentMethodUrl(updatePaymentUrl) {
  const urlWithLayout = new URL(updatePaymentUrl);
  urlWithLayout.searchParams.set('layout', 'billing-portal');
  const params = new URLSearchParams();
  params.set('url', urlWithLayout.toString());
  return `${Paths.UPDATE_PAYMENT_METHOD}?${params.toString()}`;
}